import React from 'react'

import "./elecuses.css"
import chart4 from "../../../assets/images/elec/chart1.png"

export default function ElecUses() {
  return (
    <div className='emas__elecuses'>
        <h1>Uses of Our Software</h1>
        <div className='emas__elecuses-content'>
            <div className='emas__elecuses-content_div'>
                <div>
                    <h1>Renewable Energy Intergration</h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Cras ornare arcu dui vivamus arcu. Leo urna molestie at elementum eu facilisis sed odio morbi. Tortor pretium viverra suspendisse potenti nullam ac tortor. Pretium quam vulputate dignissim suspendisse in.</p>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Cras ornare arcu dui vivamus arcu. Leo urna molestie at elementum eu facilisis sed odio morbi. Tortor pretium viverra suspendisse potenti nullam ac tortor. Pretium quam vulputate dignissim suspendisse in.</p>
                    <img className='emas__elecuses-content_div-image' src={chart4} alt="chart"/>
                </div>
                <div className='emas__elecuses-content_image2'>
                    <img src={chart4} alt="chart"/>
                </div>
            </div>
            <div className='emas__elecuses-content_div'>
                <div className='emas__elecuses-content_image2' >
                    <img src={chart4} alt="chart"/>
                </div>
                <div>
                    <h1>Exit of Coal Power Generation</h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Cras ornare arcu dui vivamus arcu. Leo urna molestie at elementum eu facilisis sed odio morbi. Tortor pretium viverra suspendisse potenti nullam ac tortor. Pretium quam vulputate dignissim suspendisse in.</p>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Cras ornare arcu dui vivamus arcu. Leo urna molestie at elementum eu facilisis sed odio morbi. Tortor pretium viverra suspendisse potenti nullam ac tortor. Pretium quam vulputate dignissim suspendisse in.</p>
                    <img className='emas__elecuses-content_div-image' src={chart4} alt="chart"/>
                </div>
            </div>
            <div className='emas__elecuses-content_div'>
                <div>
                    <h1>Lorem Ipsum Delum Cresta</h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Cras ornare arcu dui vivamus arcu. Leo urna molestie at elementum eu facilisis sed odio morbi. Tortor pretium viverra suspendisse potenti nullam ac tortor. Pretium quam vulputate dignissim suspendisse in.</p>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Cras ornare arcu dui vivamus arcu. Leo urna molestie at elementum eu facilisis sed odio morbi. Tortor pretium viverra suspendisse potenti nullam ac tortor. Pretium quam vulputate dignissim suspendisse in.</p>
                    <img className='emas__elecuses-content_div-image' src={chart4} alt="chart"/>
                </div>
                <div className='emas__elecuses-content_image2'>
                    <img src={chart4} alt="chart"/>
                </div>
            </div>
        </div>
    </div>
  )
}
